import React, { FC, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { LoadingButton } from "@mui/lab";

interface Props {
  title: string;
  body: JSX.Element;
  isLoading: boolean;
  onOkay: () => void;
  onClose: () => void;
}

export const VerificationDialog: FC<Props> = ({
  title,
  body,
  isLoading,
  onOkay,
  onClose,
}) => {
  const [dialogState, setDialogState] = useState(true);
  const closeDialog = () => {
    setDialogState(false);
    onClose();
  };

  return (
    <Dialog
      open={dialogState}
      onClose={closeDialog}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          {body}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={closeDialog} disabled={isLoading}>
          Disagree
        </Button>
        <LoadingButton loading={isLoading} onClick={onOkay} autoFocus>
          Agree
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
